(function () {
  function init() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    document.documentElement.classList.add('kg-infinite');

    var sentinel = document.createElement('div');
    sentinel.className = 'kg-scroll-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.textContent = '​';
    container.parentNode.insertBefore(sentinel, container.nextSibling);

    var status = document.createElement('div');
    status.className = 'kg-scroll-status';
    status.hidden = true;
    status.textContent = 'Mehr Produkte werden geladen …';
    container.parentNode.insertBefore(status, sentinel);

    var loading = false;

    function grid() {
      return document.getElementById('product-grid');
    }

    function productLinks(root) {
      return Array.prototype.map.call(
        root.querySelectorAll('a[href*="/products/"]'),
        function (a) {
          return a.getAttribute('href').split('?')[0];
        }
      );
    }

    var io = new IntersectionObserver(
      function (entries) {
        if (loading) return;
        var visible = false;
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) visible = true;
        }
        if (!visible) return;

        var g = grid();
        if (!g || g.dataset.kgDone === 'true') return;

        var page = parseInt(g.dataset.kgPage || '1', 10) + 1;
        var url = new URL(window.location.href);
        url.searchParams.set('page', page);

        loading = true;
        status.hidden = false;
        fetch(url.toString())
          .then(function (r) {
            return r.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.getElementById('product-grid');
            var current = grid();
            if (!newGrid || !current) {
              if (current) current.dataset.kgDone = 'true';
              return;
            }
            var existing = productLinks(current);
            var added = 0;
            Array.prototype.forEach.call(newGrid.children, function (item) {
              var links = productLinks(item);
              if (links.length && existing.indexOf(links[0]) !== -1) return;
              current.appendChild(document.importNode(item, true));
              added++;
            });
            current.dataset.kgPage = String(page);
            if (added === 0) current.dataset.kgDone = 'true';
          })
          .catch(function () {})
          .finally(function () {
            loading = false;
            status.hidden = true;
          });
      },
      { rootMargin: '800px 0px' }
    );

    io.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
